module.exports = __webpack_public_path__ + "files/b616b759a0752ddfc1e04b667403152c.svg";